/** Local RU/EN additions, following the existing entry/emailLink dictionaries. */
export const tmaEmailMessages = {
  en: {
    savedHint: 'Confirm the email saved in your account to continue.',
    sendCode: 'Get a code',
    skip: 'Skip for now',
    continueTitle: 'Continue in GonkaGame',
    continueHint: 'Complete the sign-in step to open your account.',
    exit: 'Close Mini App',
  },
  ru: {
    savedHint: 'Чтобы продолжить, подтвердите почту, сохранённую в аккаунте.',
    sendCode: 'Получить код',
    skip: 'Пропустить',
    continueTitle: 'Продолжить в GonkaGame',
    continueHint: 'Завершите вход, чтобы открыть кабинет.',
    exit: 'Выйти из Mini App',
  },
} as const
